// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ms-9";
export var arrowButtonContainer = "_ms-5";
export var arrowButtonIcon = "_ms-6";
export var carouselArrowButton = "_ms-2";
export var carouselElementContainer = "_ms-1";
export var currentSlide = "_ms-8";
export var left = "_ms-3";
export var otherSlide = "_ms-a";
export var productCarouselContainer = "_ms-0";
export var right = "_ms-4";
export var sliderOverflow = "_ms-7";